<!-- 组队瓜分奖品 -->
<template>
  <div class="createPlayStep new-input-box" v-loading="loading">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-back
        @back="returnBack()"
        :title="['互动广场']"
        :subTitle="activityData.name"
        style="padding-bottom: 0"
      ></jd-back>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0 || localStepNum == 1">
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="backgroundForm"
          label-width="150px"
        >
          <informationForm
            @selectPeopleSure="selectPeopleSure"
            :defaultActMember.sync="actMember"
            :defaultActivityStartTime="activityStartTime"
            :defaultActivityEndTime="activityEndTime"
            :plusObject.sync="ruleDTO.plusObject"
            :openCardStartTime.sync="ruleDTO.openCardStartTime"
            :openCardEndTime.sync="ruleDTO.openCardEndTime"
            :peopleSelected.sync="peopleSelected"
            ref="informationForm"
            v-model="ruleForm"
            :isEdit="false"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum"
            :needNonMember="true"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <div>
            <jd-title label="奖品设置" type="bold"></jd-title>
            <el-form-item label="团长奖励：" required>
              <el-radio-group
                v-model="commanderForm.commanderPrizeType"
                :disabled="activityData.isStart"
              >
                <el-radio :label="0">统一奖品</el-radio>
                <el-radio :label="1">阶梯奖品</el-radio>
              </el-radio-group>
              <div
                style="
                  background: #fafafa;
                  padding: 20px 20px 20px 0;
                  border-radius: 4px;
                "
              >
                <template v-if="commanderForm.commanderPrizeType == 0">
                  <el-form-item label="开团要求：" required label-width="100px">
                    <el-radio-group
                      v-model="commanderForm.openTeamType"
                      :disabled="activityData.isStart"
                    >
                      <el-radio :label="0">符合参与对象可直接开团</el-radio>
                      <el-radio :label="1"
                        >符合参与对象，并且需要完成任务后方可开团</el-radio
                      >
                    </el-radio-group>
                    <div
                      v-if="commanderForm.openTeamType == 1"
                      style="
                        background: #fff;
                        padding: 20px 20px 5px 0;
                        border-radius: 4px;
                      "
                    >
                      <el-form-item
                        label="任务设置："
                        required
                        label-width="100px"
                      >
                        <div class="flexc">
                          <jd-button
                            type="blue"
                            :disabled="
                              backgroundOpacity ||
                              taskDataList.length >= 3 ||
                              activityData.isStart
                            "
                            @click="addTask"
                            >+添加任务（{{ taskDataList.length }}/3）</jd-button
                          >
                          <jd-tip class="ml8" style="width: fit-content">
                            完成全部任务即可成功开团
                          </jd-tip>
                        </div>
                        <jd-table
                          v-if="taskDataList.length > 0"
                          :tableData="taskDataList"
                          class="mt12"
                        >
                          <el-table-column label="序号" width="80px">
                            <template slot-scope="scope">
                              <span>{{ scope.$index + 1 }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="任务类型">
                            <template slot-scope="scope">
                              <span>{{
                                getTaskType(taskTypeOptions, scope.row)
                              }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="任务条件">
                            <template slot-scope="scope">
                              <span>{{ getCondition(scope.row) }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="操作">
                            <template slot-scope="scope">
                              <jd-button
                                type="blueText"
                                :disabled="
                                  backgroundOpacity || activityData.isStart
                                "
                                @click="editTask(scope.row, scope.$index)"
                                >修改</jd-button
                              >
                              <jd-button
                                type="blueText"
                                :disabled="
                                  backgroundOpacity ||
                                  (activityData.isStart &&
                                    taskDataList.length <= 1)
                                "
                                @click="deleteTask(scope.$index)"
                                >删除</jd-button
                              >
                              <jd-button
                                type="blueText"
                                v-if="scope.$index != 0"
                                :disabled="backgroundOpacity"
                                @click="upTask(taskDataList, scope.$index)"
                                >上移</jd-button
                              >
                              <jd-button
                                type="blueText"
                                @click="downTask(taskDataList, scope.$index)"
                                :disabled="backgroundOpacity"
                                v-if="scope.$index != taskDataList.length - 1"
                                >下移</jd-button
                              >
                            </template>
                          </el-table-column>
                        </jd-table>
                      </el-form-item>
                    </div>
                  </el-form-item>

                  <el-form-item label="成团人数：" required label-width="100px">
                    邀请
                    <el-input
                      v-model="commanderForm.inviteTeamNum"
                      placeholder="请输入成团人数"
                      @input="
                        commanderForm.inviteTeamNum = getNumberData(
                          1,
                          $event,
                          0,
                          1,
                          999
                        )
                      "
                      style="width: 200px; margin: 0 8px"
                      :disabled="activityData.isStart"
                    />
                    人加入团队可得
                  </el-form-item>

                  <el-form-item label="奖品设置：" required label-width="100px">
                    <div style="max-width: 1300px">
                      <jd-table :tableData="tableData">
                        <el-table-column label="排序" width="50">
                          <template slot-scope="scope">
                            <span>{{ scope.$index + 1 }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column label="奖品类型">
                          <template slot-scope="scope">
                            <span>{{
                              getPrizeTypeName(scope.row.prizeType)
                            }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="值"
                          width="100"
                          prop="price"
                        ></el-table-column>
                        <el-table-column label="奖品名称（12字内）" width="270">
                          <template slot="header">
                            <span style="color: red">*</span>奖品名称（12字内）
                          </template>
                          <template slot-scope="scope">
                            <el-input
                              v-model="scope.row.title"
                              maxlength="12"
                              show-word-limit
                              style="width: 230px"
                              placeholder="请输入"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="奖品数量" width="150">
                          <template slot="header">
                            <span style="color: red">*</span>奖品数量
                          </template>
                          <template slot-scope="scope">
                            <el-input
                              v-model.number="scope.row.totalAmount"
                              @input.native="
                                (e) =>
                                  (scope.row.totalAmount = checkputn(
                                    e,
                                    scope.row
                                  ))
                              "
                              placeholder="请输入"
                              @input="
                                (scope.row.totalAmount = getNumberData(
                                  1,
                                  $event,
                                  0,
                                  1,
                                  999999
                                )),
                                  prizeNum(scope.row)
                              "
                              @blur="beAdd(scope.row)"
                              :disabled="
                                (activityData.isStart && !scope.row.minNum) ||
                                activityData.isStart ||
                                backgroundOpacity
                              "
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column label="每日发放限额" width="120">
                          <template slot-scope="scope">
                            <dailyLimitConfig
                              :row="scope.row"
                              :backgroundOpacity="backgroundOpacity"
                              :limitBtnDisabled="backgroundOpacity"
                            ></dailyLimitConfig>
                          </template>
                        </el-table-column>
                        <el-table-column label="图片" width="150">
                          <template slot-scope="scope">
                            <img
                              v-if="scope.row.logo"
                              :src="scope.row.logo"
                              style="width: 56px; height: 56px"
                            />
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="剩余库存"
                          width="180"
                          v-if="activityData.isStart"
                        >
                          <template slot-scope="scope">
                            <el-input
                              v-model="scope.row.remanentAmount"
                              style="width: 80px"
                              disabled
                            ></el-input>
                            份
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="操作"
                          fixed="right"
                          min-width="180"
                          align="center"
                        >
                          <template slot-scope="scope">
                            <jd-button
                              type="blueText"
                              :disabled="
                                backgroundOpacity || activityData.isStart
                              "
                              @click="centerVis(scope, 0)"
                              >选择奖品</jd-button
                            >
                            <jd-button
                              type="blueText"
                              v-if="activityData.isStart && !backgroundOpacity"
                              @click="addStock(scope, 0)"
                              >增加库存</jd-button
                            >
                          </template>
                        </el-table-column>
                      </jd-table>
                      <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
                    </div>
                  </el-form-item>
                </template>

                <template v-if="commanderForm.commanderPrizeType == 1">
                  <el-form-item label="阶梯设置：" required label-width="100px">
                    <div class="flexc">
                      <jd-button
                        type="blue"
                        v-if="!activityData.isStart && !backgroundOpacity"
                        @click="addStep"
                        >+添加阶梯({{
                          prizeSettingListStep.length
                        }}/10)</jd-button
                      >
                      <jd-tip class="ml8" style="width: fit-content"
                        >*不同阶梯的团队成员不可重复，即每个阶梯独立开团</jd-tip
                      >
                    </div>
                    <div
                      class="prize_box_step"
                      v-for="(item, index) in prizeSettingListStep"
                      :key="index"
                    >
                      <div class="prize_box_step_top">
                        <span>阶梯{{ index + 1 }}</span>
                        <i
                          v-if="prizeSettingListStep.length > 2"
                          class="el-icon-delete prize_box_step_top__delete"
                          @click="deleteStep(index)"
                        ></i>
                      </div>
                      <div class="prize_box_step_center">
                        <el-form-item
                          label="开团要求："
                          required
                          label-width="100px"
                        >
                          <el-radio-group
                            v-model="item.openTeamType"
                            :disabled="activityData.isStart"
                          >
                            <el-radio :label="0"
                              >符合参与对象可直接开团</el-radio
                            >
                            <el-radio :label="1"
                              >符合参与对象，并且需要完成任务后方可开团</el-radio
                            >
                          </el-radio-group>
                          <div
                            v-if="item.openTeamType == 1"
                            style="
                              background: #fafafa;
                              padding: 20px 20px 5px 0;
                              border-radius: 4px;
                              margin-right: 20px;
                            "
                          >
                            <el-form-item
                              label="任务设置："
                              required
                              label-width="100px"
                            >
                              <div class="flexc">
                                <jd-button
                                  type="blue"
                                  :disabled="
                                    backgroundOpacity ||
                                    item.taskList.length >= 3 ||
                                    activityData.isStart
                                  "
                                  @click="addTask(index)"
                                  >+添加任务（{{
                                    item.taskList.length
                                  }}/3）</jd-button
                                >
                                <jd-tip
                                  class="ml8"
                                  style="width: fit-content"
                                  :isNeedMarginLeft="true"
                                >
                                  完成全部任务即可成功开团
                                </jd-tip>
                              </div>
                              <jd-table
                                v-if="item.taskList.length > 0"
                                :tableData="item.taskList"
                                class="mt12"
                                style="width: 1000px"
                              >
                                <el-table-column label="序号" width="80px">
                                  <template slot-scope="scope">
                                    <span>{{ scope.$index + 1 }}</span>
                                  </template>
                                </el-table-column>
                                <el-table-column label="任务类型">
                                  <template slot-scope="scope">
                                    <span>{{
                                      getTaskType(taskTypeOptions, scope.row)
                                    }}</span>
                                  </template>
                                </el-table-column>
                                <el-table-column
                                  label="任务条件"
                                  prop="condition"
                                >
                                  <template slot-scope="scope">
                                    <span>{{ getCondition(scope.row) }}</span>
                                  </template>
                                </el-table-column>
                                <el-table-column label="操作">
                                  <template slot-scope="scope">
                                    <jd-button
                                      type="blueText"
                                      :disabled="
                                        backgroundOpacity ||
                                        activityData.isStart
                                      "
                                      @click="
                                        editTask(scope.row, scope.$index, index)
                                      "
                                      >修改</jd-button
                                    >
                                    <jd-button
                                      type="blueText"
                                      :disabled="
                                        backgroundOpacity ||
                                        (activityData.isStart &&
                                          item.taskList.length <= 1)
                                      "
                                      @click="deleteTask(scope.$index, index)"
                                      >删除</jd-button
                                    >
                                    <jd-button
                                      type="blueText"
                                      v-if="scope.$index != 0"
                                      :disabled="backgroundOpacity"
                                      @click="
                                        upTask(item.taskList, scope.$index)
                                      "
                                      >上移</jd-button
                                    >
                                    <jd-button
                                      type="blueText"
                                      @click="
                                        downTask(item.taskList, scope.$index)
                                      "
                                      :disabled="backgroundOpacity"
                                      v-if="
                                        scope.$index != item.taskList.length - 1
                                      "
                                      >下移</jd-button
                                    >
                                  </template>
                                </el-table-column>
                              </jd-table>
                            </el-form-item>
                          </div>
                        </el-form-item>

                        <el-form-item
                          label="成团人数："
                          required
                          label-width="100px"
                        >
                          邀请
                          <el-input
                            v-model="item.inviteTeamNum"
                            placeholder="请输入成团人数"
                            @input="
                              item.inviteTeamNum = getNumberData(
                                1,
                                $event,
                                0,
                                1,
                                999
                              )
                            "
                            style="width: 200px; margin: 0 8px"
                            :disabled="activityData.isStart"
                          />
                          人加入团队可得
                        </el-form-item>

                        <el-form-item
                          label="奖品设置："
                          required
                          label-width="100px"
                        >
                          <jd-table
                            :tableData="item.table"
                            style="width: 1200px"
                          >
                            <el-table-column
                              label="排序"
                              width="50"
                              align="center"
                            >
                              <template slot-scope="scope">
                                <span>{{ scope.$index + 1 }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column label="奖品类型">
                              <template slot-scope="scope">
                                <span>{{
                                  getPrizeTypeName(scope.row.prizeType)
                                }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              label="值"
                              width="100"
                              prop="price"
                              align="center"
                            ></el-table-column>

                            <el-table-column
                              label="奖品名称（12字内）"
                              width="270"
                            >
                              <template #header>
                                <span style="color: red">*</span
                                >奖品名称（12字内）
                              </template>
                              <template slot-scope="scope">
                                <el-input
                                  v-model="scope.row.title"
                                  maxlength="12"
                                  show-word-limit
                                  style="width: 230px"
                                  placeholder="请输入"
                                ></el-input>
                              </template>
                            </el-table-column>

                            <el-table-column label="奖品数量" width="150">
                              <template #header>
                                <span style="color: red">*</span>奖品数量
                              </template>
                              <template slot-scope="scope">
                                <el-input
                                  v-model="scope.row.totalAmount"
                                  @input="
                                    scope.row.totalAmount = getNumberData(
                                      1,
                                      $event,
                                      0,
                                      1,
                                      999999
                                    )
                                  "
                                  class="inputcount"
                                  style="width: 120px"
                                  placeholder="请输入"
                                  :disabled="
                                    (activityData.isStart &&
                                      !scope.row.minNum) ||
                                    backgroundOpacity
                                  "
                                ></el-input>
                              </template>
                            </el-table-column>
                            <el-table-column label="每日发放限额" width="120">
                              <template slot-scope="scope">
                                <dailyLimitConfig
                                  :row="scope.row"
                                  :backgroundOpacity="backgroundOpacity"
                                  :limitBtnDisabled="backgroundOpacity"
                                ></dailyLimitConfig>
                              </template>
                            </el-table-column>
                            <el-table-column label="图片" width="80">
                              <template slot-scope="scope">
                                <img
                                  v-if="scope.row.logo"
                                  :src="scope.row.logo"
                                  style="width: 56px; height: 56px"
                                />
                              </template>
                            </el-table-column>

                            <el-table-column
                              label="剩余库存"
                              width="180"
                              v-if="activityData.isStart"
                            >
                              <template slot-scope="scope">
                                <el-input
                                  v-model.number="scope.row.remanentAmount"
                                  style="width: 80px"
                                  disabled
                                ></el-input>
                                份
                              </template>
                            </el-table-column>

                            <el-table-column
                              label="操作"
                              width="260"
                              fixed="right"
                            >
                              <template slot-scope="scope">
                                <div class="flex-center">
                                  <jd-button
                                    type="blueText"
                                    @click="centerVis(scope, 1, index)"
                                    :disabled="
                                      backgroundOpacity || activityData.isStart
                                    "
                                    >选择奖品</jd-button
                                  >
                                  <jd-button
                                    type="blueText"
                                    v-if="activityData.isStart"
                                    @click="addStock(scope, 1, index)"
                                    >增加库存</jd-button
                                  >
                                </div>
                              </template>
                            </el-table-column>
                          </jd-table>
                          <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
                        </el-form-item>
                      </div>
                    </div>
                  </el-form-item>
                </template>
              </div>
            </el-form-item>

            <el-form-item label="团员奖励：">
              <div style="max-width: 1300px">
                <jd-tip
                  >每个被邀请人成功加入团队后最多可获得一个奖品，不设置则表示团员无奖品</jd-tip
                >
                <jd-table class="mt12" :tableData="teamMemberTable">
                  <el-table-column label="排序" align="center" width="50">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="奖品类型" align="center">
                    <template slot-scope="scope">
                      <span>{{ getPrizeTypeName(scope.row.prizeType) }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="值"
                    width="100"
                    prop="price"
                    align="center"
                  ></el-table-column>
                  <el-table-column label="奖品名称（12字内）" width="270">
                    <template #header>
                      <span style="color: red">*</span>奖品名称（12字内）
                    </template>
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.title"
                        maxlength="12"
                        show-word-limit
                        style="width: 230px"
                        placeholder="请输入"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="奖品数量" width="150">
                    <template #header>
                      <span style="color: red">*</span>奖品数量
                    </template>
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.totalAmount"
                        @input="
                          scope.row.totalAmount = getNumberData(
                            1,
                            $event,
                            0,
                            1,
                            999999
                          )
                        "
                        class="inputcount"
                        style="width: 120px"
                        placeholder="请输入"
                        :disabled="
                          (activityData.isStart && !scope.row.minNum) ||
                          backgroundOpacity
                        "
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="每日发放限额" width="120">
                    <template slot-scope="scope">
                      <dailyLimitConfig
                        :row="scope.row"
                        :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"
                      ></dailyLimitConfig>
                    </template>
                  </el-table-column>
                  <el-table-column label="图片" width="150">
                    <template slot-scope="scope">
                      <img
                        v-if="scope.row.logo"
                        :src="scope.row.logo"
                        style="width: 56px; height: 56px"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="剩余库存"
                    width="180"
                    v-if="activityData.isStart"
                  >
                    <template slot-scope="scope">
                      <el-input
                        v-model.number="scope.row.remanentAmount"
                        style="width: 70px"
                        disabled
                      ></el-input>
                      份
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    fixed="right"
                    min-width="180"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <jd-button
                        type="blueText"
                        :disabled="backgroundOpacity || activityData.isStart"
                        @click="centerVis(scope, 2)"
                        >选择奖品</jd-button
                      >
                      <jd-button
                        type="blueText"
                        v-if="scope.row.prizeType"
                        :disabled="backgroundOpacity || activityData.isStart"
                        @click="clearPrize"
                        >清除</jd-button
                      >
                      <jd-button
                        type="blueText"
                        v-if="
                          activityData.isStart &&
                          !backgroundOpacity &&
                          scope.row.remanentAmount
                        "
                        @click="addStock(scope, 2)"
                        >增加库存</jd-button
                      >
                    </template>
                  </el-table-column>
                </jd-table>
                <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
              </div>
            </el-form-item>
          </div>
          <div>
            <jd-title label="参团限制" type="bold"></jd-title>
            <el-form-item label="团员身份要求：" required>
              <el-radio-group
                v-model="memberJoinSetting.memberJoinType"
                :disabled="activityData.isStart"
                @change="memberJoinSetting.allowLevel = ['-1']"
              >
                <el-radio :label="0">不限</el-radio>
                <el-radio :label="1">指定身份</el-radio>
              </el-radio-group>
              <div
                v-if="memberJoinSetting.memberJoinType == 1"
                style="
                  background: #fafafa;
                  padding: 20px 20px 5px 0;
                  border-radius: 4px;
                  width: fit-content;
                "
              >
                <el-form-item label-width="100px" label="参与对象：">
                  <el-checkbox-group
                    v-model="memberJoinSetting.allowLevel"
                    @change="checkLevelchange"
                    :disabled="activityData.isStart"
                  >
                    <el-checkbox label="-1" name="allowLevel">全部</el-checkbox>
                    <el-checkbox label="0" name="allowLevel"
                      >非会员</el-checkbox
                    >
                    <el-checkbox
                      v-for="(item, index) in levelList"
                      :key="index"
                      :label="index + 1 + ''"
                      name="allowLevel"
                      >{{ item }}</el-checkbox
                    >
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item label-width="100px" label="入会时间：">
                  <el-checkbox
                    v-model="memberJoinSetting.isCheckOpenCardTime"
                    :disabled="activityData.isStart"
                    >指定时间段</el-checkbox
                  >
                  <div
                    class="my_select_time"
                    style="margin-left: 8px"
                    v-if="memberJoinSetting.isCheckOpenCardTime"
                  >
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="memberJoinSetting.openCardStartTime"
                      type="datetime"
                      placeholder="开始日期"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time1"
                      :clearable="false"
                      :disabled="activityData.isStart"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="memberJoinSetting.openCardEndTime"
                      type="datetime"
                      placeholder="结束日期"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 200px; font-size: 12px"
                      class="time2"
                      :picker-options="openCardEndTimeOptionsValue"
                      :clearable="false"
                      :disabled="activityData.isStart"
                    >
                    </el-date-picker>
                    <i
                      v-if="!activityData.isStart || !backgroundOpacity"
                      class="el-icon-circle-close date_icon1"
                      @click="clearMembershipTime"
                    ></i>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                  <div class="tips_red">注意：该条件对【非会员】身份不生效</div>
                </el-form-item>
              </div>
            </el-form-item>
            <el-form-item label="参团限制：" required>
              <el-radio-group
                v-model="memberJoinSetting.filterInviteRuleType"
                :disabled="activityData.isStart"
              >
                <el-radio :label="0">过滤同一活动中被邀请过的人</el-radio>
                <el-radio :label="1">过滤所有活动中被邀请过的人</el-radio>
                <el-tooltip class="item" effect="light" placement="right-start">
                  <div slot="content">
                    <div>被邀请人过滤规则：</div>
                    <div>
                      ①过滤同一活动中被邀请过的人：即表示同一个人在同一个活动中仅能被有效邀请1次；
                    </div>
                    <div>
                      ②过滤所有活动中被邀请过的人：即表示同一个人在所有活动中仅能被有效邀请1次；
                    </div>
                  </div>
                  <el-button type="text" style="width: 35px">
                    <i class="el-icon-question"></i>
                  </el-button>
                </el-tooltip>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="参团要求：" required>
              <el-radio-group
                v-model="memberJoinSetting.openTeamType"
                :disabled="activityData.isStart"
              >
                <el-radio :label="0">符合团员身份要求即可参团</el-radio>
                <el-radio :label="1"
                  >符合团员身份要求，并且需要完成任务后方可参团</el-radio
                >
              </el-radio-group>
              <div
                v-if="memberJoinSetting.openTeamType == 1"
                style="
                  background: #fafafa;
                  padding: 20px 20px 5px 0;
                  border-radius: 4px;
                "
              >
                <el-form-item label="任务设置：" required label-width="100px">
                  <div class="flexc">
                    <jd-button
                      type="blue"
                      :disabled="
                        backgroundOpacity ||
                        teamMemberTaskList.length >= 3 ||
                        activityData.isStart
                      "
                      @click="addMemberTask"
                      >+添加任务（{{ teamMemberTaskList.length }}/3）</jd-button
                    >
                    <jd-tip class="ml8" style="width: fit-content">
                      完成全部任务即可成功开团
                    </jd-tip>
                  </div>
                  <jd-table
                    v-if="teamMemberTaskList.length > 0"
                    :tableData="teamMemberTaskList"
                  >
                    <el-table-column label="序号" width="80px">
                      <template slot-scope="scope">
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="任务类型">
                      <template slot-scope="scope">
                        <span>{{
                          getTaskType(taskTypeOptions, scope.row)
                        }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="任务条件" prop="condition">
                      <template slot-scope="scope">
                        <span>{{ getCondition(scope.row) }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <jd-button
                          type="blueText"
                          :disabled="backgroundOpacity || activityData.isStart"
                          @click="
                            editMemberTask(scope.row, scope.$index, -1, true)
                          "
                          >修改</jd-button
                        >
                        <jd-button
                          type="blueText"
                          :disabled="
                            backgroundOpacity ||
                            (activityData.isStart &&
                              teamMemberTaskList.length <= 1)
                          "
                          @click="deleMemberTask(scope.$index)"
                          >删除</jd-button
                        >
                        <jd-button
                          type="blueText"
                          v-if="scope.$index != 0"
                          :disabled="backgroundOpacity"
                          @click="upTask(teamMemberTaskList, scope.$index)"
                          >上移</jd-button
                        >
                        <jd-button
                          type="blueText"
                          @click="downTask(teamMemberTaskList, scope.$index)"
                          :disabled="backgroundOpacity"
                          v-if="scope.$index != teamMemberTaskList.length - 1"
                          >下移</jd-button
                        >
                      </template>
                    </el-table-column>
                  </jd-table>
                </el-form-item>
              </div>
            </el-form-item>
          </div>
          <activityPageSettings
            isShowShopName
            isShowMoreSet
            :cusTemplateJSON.sync="ruleDTO.cusTemplateJSON"
            :isNeedSetBG="true"
            :giftList="giftList"
            themeTitle="主题"
            :templateId="templateId"
            @selectTemplate="selectTemplate"
            :widthNumber="750"
            :heightNumber="2002"
            previewKey="url"
            templatekey="imageUrl"
            :isShowDesignNumber="false"
            :isCustomPreview="true"
            :downloadTemplateUrl="baseUrl + 'zdgfjp-template.psd'"
            :designSpecificationsUrl="baseUrl + 'zdgfjp_rule.png'"
            v-model="customerPaperwork"
          >
           <template #customPreview>
              <previewPageDialog
              :ruleForm="{
                ...ruleForm,
                ...commanderForm,
                tableData,
                prizeSettingListStep,
                teamMemberTable,
                backgroundImage: templateObj.url,
                cusTemplateJSON: ruleDTO.cusTemplateJSON
              }"
              :customerPaperwork="customerPaperwork"
              :btnBgUrl="templateObj.url2"
              :baseUrl="baseUrl"
            ></previewPageDialog>
           </template>
           <template #otherSet>
              <el-form-item label="按钮设置:" required>
                <div
                  style="
                    background: #f4f6fa;
                    padding: 20px 20px 20px 0;
                    width: fit-content;
                  "
                >
                  <el-form-item label="按钮背景图：" label-width="120px">
                    <div class="buttonGroup">
                      <el-upload
                        class="upload"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        :on-success="handleUpload"
                      >
                        <div class="btn-bg" v-if="customerPaperwork.btnBgUrl">
                          <img
                            :src="customerPaperwork.btnBgUrl"
                            style="width: 100%; height: auto"
                          />
                        </div>
                        <jd-button
                          v-else
                          type="blueText"
                          label="自定义上传"
                          :disabled="backgroundOpacity"
                        ></jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        @click="customerPaperwork.btnBgUrl = ''"
                        style="margin: 0 16px 0 16px"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                      <span class="color-style">尺寸建议：460*112px</span>
                    </div>
                  </el-form-item>
                  <el-form-item
                    label="按钮文字色："
                    label-width="120px"
                    style="margin-bottom: 0"
                  >
                    <div class="buttonGroup">
                      <el-color-picker
                        v-model="customerPaperwork.btnWordColor"
                        size="small"
                      ></el-color-picker>
                      <jd-button
                        type="blueText"
                        style="margin: 0 12px 0 16px"
                        @click="customerPaperwork.btnWordColor = currrentRgb"
                        :disabled="backgroundOpacity"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                </div>
              </el-form-item>
              <el-form-item label="奖品剩余库存：" :label-width="labelWidth">
                <el-radio v-model="customerPaperwork.hideStock" :label="0"
                  >不显示</el-radio
                >
                <el-radio v-model="customerPaperwork.hideStock" :label="1">
                  显示（C端活动页奖品显示剩余库存）
                </el-radio>
              </el-form-item>
           </template>
          </activityPageSettings>
 
          <!-- <jd-title label="进店设置" type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group
              v-model="ruleDTO.goShopSetting"
              :disabled="activityData.isStart"
              @change="onShopSetChange"
            >
              <el-radio :label="0">进入店铺首页</el-radio>
              <el-radio :label="1">跳转指定小程序</el-radio>
              <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color: #f56c6c">
              部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
            </div>
          </el-form-item>
          <div v-if="ruleDTO.goShopSetting == 1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
            <el-form-item label="页面路径path:">
              <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleDTO.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：path若不写，则默认进入小程序主页。
              </div>
            </el-form-item>
          </div>
          <el-form-item
            label="指定链接:"
            required
            v-if="ruleDTO.goShopSetting == 2"
          >
            <el-input
              type="textarea"
              placeholder="请输入指定链接"
              style="width: 425px; margin-left: 8px"
              show-word-limit
              v-model="ruleDTO.goShopUrl"
              :maxlength="1000"
              :disabled="activityData.isStart"
            ></el-input>
            <div style="color: #f56c6c">
              注意：仅可填写京东域内的
              H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
            </div>
          </el-form-item> -->
          <exposureList
            :defaultExposureSwitch.sync="ruleForm.isExposureItem"
            v-model="itemListFor"
            :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
            :limitNum="limitNum"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleDTO"></sharFrom>
          <activityRules
            :isForceRemind.sync="isForceRemind"
            :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition"
            v-model="ruleForm.ruleDescription"
            :activityData="activityData"
            :valueRow="valueRow"
            @generateRule="generateRule"
          ></activityRules>
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0 || localStepNum == 1">
      <jd-button
        v-if="localStepNum != 0"
        v-show="!itemId"
        style="margin-right: 8px"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>

      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>

    <!-- 保存设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div v-loading="saveLoading">
        <div style="line-height: 25px; margin-bottom: 30px">
          <p>
            1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
          </p>
          <p>
            2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
          </p>
        </div>

        <el-checkbox v-model="checked" label="地址" name="partner"
          >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
        >
      </div>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          v-loading="saveLoading"
          >确 定</jd-button
        >
      </div>
    </el-dialog>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
    <!-- 添加团长统一/阶梯奖品任务弹窗 -->
    <addTaskDialog
      v-if="taskDialog"
      :taskDataLists="
        isStepTask ? prizeSettingListStep[selectedStep].taskList : taskDataList
      "
      :taskDialog="taskDialog"
      :currentIndex="currentIndex"
      :isTaskEdit="isTaskEdit"
      :taskTypeOptions="taskTypeOptions"
      :taskData="taskForm"
      :isShowHis="true"
      @getTaskDataList="getTaskDataList"
      @closeTask="taskDialog = false"
      :ruleForm="ruleForm"
      :venderType="venderType"
    ></addTaskDialog>
    <!-- 添加团员任务弹窗 -->
    <addTaskDialog
      v-if="memberTaskDialog"
      :taskDataLists="teamMemberTaskList"
      :taskDialog="memberTaskDialog"
      :currentIndex="memberCurrentIndex"
      :isTaskEdit="isMemberTaskEdit"
      :taskTypeOptions="taskTypeOptions"
      :taskData="memberTaskForm"
      :isShowHis="true"
      @getTaskDataList="getMemberTaskDataList"
      @closeTask="memberTaskDialog = false"
      :ruleForm="ruleForm"
      :venderType="venderType"
    ></addTaskDialog>
    <!-- 奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :actType="64"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData"
    >
    </selectProduct>
  </div>
</template>

<script>
import SelectGoods from "@/components/selectGoodsMonitor2";
import selectProduct from "./select_product_componentization.vue";
import {
  saveActivityCommon,
  getActivityDetailCommon,
} from "@/api/jhk/integralCenter/PointActivityAnalyticController.js";
import { sellerImage } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import draggable from "vuedraggable";
import addPrizeNum from "./components/add-prize-num.vue";
import setLimitDialog from "@/views/interactiveMarketing/activity/components/_components/setLimitDialog.vue";
import informationForm from "./components/informationForm.vue";
import exposureList from "./components/exposureList.vue";
import sharFrom from "./components/sharFrom.vue";
import activityRules from "./components/activityRules.vue";
import activityPageSettings from "./components/activityPageSettings.vue";
import addTaskDialog from "./components/unlock_task_dialog.vue";
import previewPageDialog from "./components/preview_page_dialog.vue";
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

export default {
  components: {
    SelectGoods,
    selectProduct,
    draggable,
    addPrizeNum,
    setLimitDialog,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    addTaskDialog,
    previewPageDialog,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      echoDate: null,
      isForceRemind: false,
      isKeyActivity: 0,
      placementPosition: [],
      itemArr: [],
      saveLoading: false,
      // 团长奖品设置表单
      commanderForm: {
        commanderPrizeType: 0,
        openTeamType: 0,
        inviteTeamNum: "",
      },
      baseUrl: "https://cdn-image.yucrm.cn/images/dy/formTeamToShare/",
      memberJoinSetting: {
        memberJoinType: 0,
        allowLevel: ["-1"],
        isCheckOpenCardTime: false,
        openCardStartTime: "",
        openCardEndTime: "",
        filterInviteRuleType: 0,
        openTeamType: 0,
      },
      tableIndex: 2,
      selectPrizeType: 0, // 0:统一奖品 1:团员奖品
      showSelectProduct: false,
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      stepPrizeIndex: -1,
      toAddItem: null,
      isShowAddNum: false,
      prizeIndex: "",
      // 奖品列表
      tableData: [
        {
          sort: 0,
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ],
      teamMemberTable: [
        {
          sort: 0,
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ],
      taskForm: {}, //团长任务编辑时接收
      memberTaskForm: {}, //团员任务编辑时接收
      taskTypeOptions: [
        {
          label: "购买商品",
          value: 17,
        },
        {
          label: "加入会员",
          value: 7,
          taskCondition: "成功加入会员",
        },
        {
          label: "关注店铺",
          value: 6,
          taskCondition: "成功关注店铺",
        },
        {
          label: "预约商品",
          value: 12,
        },
        {
          label: "浏览商品",
          value: 13,
          activityType: 1,
        },
        {
          label: "浏览店铺",
          value: 2,
          taskCondition: "成功浏览店铺1次",
          activityType: 1,
        },
      ],
      currentIndex: 0, //团长当前选中的任务
      memberCurrentIndex: 0, //团员当前选中的任务
      taskDataList: [], //团长统一奖品任务
      prizeSettingListStep: [
        // 团长阶梯奖品务
        {
          openTeamType: 0, // 开团要求 0 符合参与对象可直接开团 1 符合参与对象，并且需要完成任务后方可开团
          inviteTeamNum: null, // 邀请人数
          table: [
            {
              assetsId: null, // 资产项id(计划id优惠卷id商品id)
              prizeType: 0,
              price: null,
              logo: null,
              title: "",
              totalAmount: null,
            },
          ],
          taskList: [],
        },
        {
          openTeamType: 0, // 开团要求 0 符合参与对象可直接开团 1 符合参与对象，并且需要完成任务后方可开团
          inviteTeamNum: null, // 邀请人数
          table: [
            {
              assetsId: null, // 资产项id(计划id优惠卷id商品id)
              prizeType: 0,
              price: null,
              logo: null,
              title: "",
              totalAmount: null,
            },
          ],
          taskList: [],
        },
      ],
      teamMemberTaskList: [], //团员任务
      // 任务设置
      isTaskEdit: false,
      taskDialog: false,
      isMemberTaskEdit: false,
      memberTaskDialog: false,
      isStepTask: false, //判断是否为阶梯
      // --end
      loading: false,
      templateObj: {},
      currrentRgb: "#ffffff",
      customerPaperwork: {
        title: "组队瓜分奖品",
        desc: "邀请好友组队瓜分奖品",
        titleColor: "#242424",
        btnWordColor: "#ffffff", //按钮字体颜色
        btnBgUrl: "",
        hideStock: 0, // 0 显示（C端活动页奖品显示剩余库存） 1 不显示
      },
      actMember: "1",
      peopleSelected: [],
      templateId: "",
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      itemListFor: [], //商品弹框选择商品数据
      joinBlackList: false,
      checked: false,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      ruleForm: {
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        allowLevel: "-1",
        activityName: "",
        openCardFollow: 0,
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "",
        isValidBlackList: 0,
      },
      ruleDTO: {
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        openCardFollow: 0, // 开卡入会后方可参与活动
        customerPaperwork: "",
        cusTemplateJSON: "",
        plusObject: 0,
        // goShopSetting: 0,
        // goShopAppId: "",
        // goShopUrl: "",
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        openCardStartTime: "",
        openCardEndTime: "",
      },
      sharePic: "",
      activityStartTime: null,
      activityEndTime: null,
      templateJson: {
        templateUItype: "",
      },

      levelList: [],
      isDraft: false,
    };
  },
  computed: {
    // 获取任务类型
    getTaskType() {
      return (arr, row) => {
        const obj = arr.find((item) => item.value == row.taskType);
        return obj.label;
      };
    },
    // 获取任务条件
    getCondition() {
      return (item) => {
        const {
          taskType,
          taskCondition,
          itemStartCount,
          orderStartPayment,
          orderType,
        } = item;
        let str = taskCondition;
        if (taskType == 3 || taskType == 13) {
          str = `成功浏览${taskCondition}件商品`;
        } else if (taskType == 12) {
          str = `成功预约${taskCondition}件商品`;
        } else if (taskType == 17) {
          str = `在规定时间范围内，购买商品大于等于：${
            itemStartCount ? `${itemStartCount}件` : ""
          }${
            orderStartPayment ? `${orderStartPayment}元` : ""
          }，且订单状态为：${orderType == 1 ? "已完成" : "已付款"}`;
        }
        return str;
      };
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId;
    }
  },
  created() {
    this.sharePic = this.getDefaultSharePic(64);
    this.ruleDTO.sharePic = this.sharePic;
    this.ruleDTO.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleDTO.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.getLevel();
    this.getDetail();
    this.buriedPoint(1, "组队瓜分奖品", "互动管理", "互动活动");
  },

  methods: {
    deleteStep(index) {
      if (this.activityData.isStart || this.backgroundOpacity) {
        return;
      } else {
        this.prizeSettingListStep.splice(index, 1);
      }
    },
    clearPrize() {
      this.teamMemberTable = [
        {
          sort: 0,
          assetsId: null, // 资产项id(计划id优惠卷id商品id)
          prizeType: 0,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
        },
      ];
    },
    addStep() {
      let length = this.prizeSettingListStep.length;
      if (length > 9) {
        return this.$message.warning("最多设置10个阶梯");
      }
      this.prizeSettingListStep.push({
        openTeamType: 0, // 开团要求 0 符合参与对象可直接开团 1 符合参与对象，并且需要完成任务后方可开团
        inviteTeamNum: null, // 邀请人数
        table: [
          {
            assetsId: null, // 资产项id(计划id优惠卷id商品id)
            prizeType: 0, // 类型 固定为实物
            price: null, // 价格
            title: "", // 商品标题
            totalAmount: null, // 总共奖品数量
            logo: null, // 自定义商品图片
          },
        ],
        taskList: [],
      });
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
        let sorts = [".png", ".jpg"];
        if (sorts.indexOf(type) < 0) {
          reject();
          this.$message.info("所选图片格式不符，请重新选择");
        } else {
          let image = new Image();
          let _URL = window.URL || window.webkitURL;
          image.onload = function () {
            const valid = image.width == width && image.height == height;
            file.isFlag = valid;
            if (valid) {
              resolve(true);
            } else {
              _this.$message.info("图片尺寸不符合要求，请重新上传");
              reject();
            }
          };
          image.src = _URL.createObjectURL(file);
        }
      });
    },
    // 奖品logo校验
    async beforeUpload(file) {
      const status = await this.imgchecked(file, 460, 112);
      if (!status) {
        return false;
      }
    },
    // 按钮背景图上传图片
    handleUpload(res, row) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.customerPaperwork.btnBgUrl = res.data;
        this.$message.success("按钮背景图上传成功");
      }
    },
    clearMembershipTime() {
      this.memberJoinSetting.openCardStartTime = "";
      this.memberJoinSetting.openCardEndTime = "";
    },
    checkLevelchange(val) {
      if (
        val[val.length - 1] == "-1" ||
        this.memberJoinSetting.allowLevel.length == 0
      ) {
        this.memberJoinSetting.allowLevel = ["-1"];
      } else {
        this.memberJoinSetting.allowLevel = val.filter((item) => item != "-1");
      }
    },
    getTheData(data, prizeType) {
      //处理奖品返回字段公共部分
      let prizeObj = {
        price: "",
        assetsId: "",
        logo: "",
        prizeType: 0,
        title: "",
      };
      if (prizeType == 1) {
        prizeObj.couponType = data.couponType;
      }
      if (data.giftType) {
        prizeObj.giftType = Number(data.giftType);
      }
      prizeObj.price = Number(data.discount);

      prizeObj.assetsId = data.couponId ? Number(data.couponId) : data.skuId;
      prizeObj.logo = data.logo || this.defaultLogo;
      prizeObj.prizeType = prizeType;

      if (prizeType == 4) {
        prizeObj.title = data.discount + "店铺积分";
      } else {
        prizeObj.title = data.name;
      }

      if (data.singleAmount) {
        prizeObj.singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        prizeObj.quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        if (!data.isGoodManage) {
          prizeObj.skuId = data.skuId;
          delete prizeObj.isGoodManage;
        } else {
          prizeObj.isGoodManage = data.isGoodManage;
        }
        prizeObj.predictSendTime = data.predictSendTime;
        prizeObj.isFollowActivityEndTime = data.isFollowActivityEndTime ? data.isFollowActivityEndTime : 0;
        prizeObj.addressFillEndTime = data.addressFillEndTime;
        prizeObj.shouldCollectExtraData = data.shouldCollectExtraData;
        prizeObj.extraQuestion = data.extraQuestion;
        prizeObj.addressFillLimit = data.addressFillLimit;
        prizeObj.commitAddressLimit = data.commitAddressLimit;
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        prizeObj.budgetRemain = data.budgetRemain;
      }
      // 实物随单发
      if (prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(prizeObj,prizeType,data);
      }

      if (this.selectPrizeType == 0) {
        // 统一奖品
        this.$set(this.tableData, this.prizeIndex, prizeObj);
      } else if (this.selectPrizeType == 1) {
        // 阶梯奖品
        this.$set(
          this.prizeSettingListStep[this.selectedStep].table,
          this.prizeIndex,
          prizeObj
        );
      } else if (this.selectPrizeType == 2) {
        // 团员奖品
        this.$set(this.teamMemberTable, this.prizeIndex, prizeObj);
      }
      this.showSelectProduct = false;
    },
    //选择奖品弹窗
    centerVis(scope, type, stepIndex) {
      // type: 0统一奖品 1:阶梯奖品 2:团员奖品
      this.selectPrizeType = type;
      this.JingdouCount.prizeCount = scope.row.totalAmount;
      if (stepIndex >= 0) {
        this.selectedStep = stepIndex;
      }
      this.prizeIndex = scope.$index;
      this.echoDate = scope.row;
      this.showSelectProduct = true;
      this.itemArr =
        type == 0
          ? this.tableData
          : type == 1
          ? this.prizeSettingListStep[stepIndex].table
          : this.teamMemberTable;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    confirmAdd(num) {
      if (this.stepPrizeIndex >= 0 && this.selectPrizeType == 1) {
        this.$set(
          this.prizeSettingListStep[this.stepPrizeIndex].table[this.prizeIndex],
          "totalAmount",
          Number(num)
        );
      } else {
        const table = {
          0: this.tableData,
          2: this.teamMemberTable,
        };
        this.$set(
          table[this.selectPrizeType][this.prizeIndex],
          "totalAmount",
          Number(num)
        );
      }
      this.isShowAddNum = false;
    },
    addStock(scope, type, stepIndex) {
      this.toAddItem = {
        ...scope.row,
        num: scope.row.totalAmount,
      };
      this.selectPrizeType = type;
      if (stepIndex >= 0) {
        this.stepPrizeIndex = stepIndex;
      }
      this.isShowAddNum = true;
      this.prizeIndex = scope.$index;
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    checkputn(e, row = {}) {
      if (
        row.quantityTotal &&
        row.price &&
        row.totalAmount &&
        row.prizeType == 2
      ) {
        let numTotal = this.$jingdouTotal({
          ...row,
          prizeCount: row.totalAmount,
        });
        if (!numTotal) {
          this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
        }
        return numTotal;
      } else {
        return row.totalAmount;
      }
    },
    // 修改团长任务
    editTask(row, $index, stepIndex) {
      if (stepIndex >= 0) {
        this.isStepTask = true;
        this.selectedStep = stepIndex;
      } else {
        this.isStepTask = false;
        this.selectedStep = null;
      }
      this.currentIndex = $index;
      const copyRow = JSON.parse(JSON.stringify(row));
      this.isTaskEdit = true;
      this.taskForm = copyRow;
      this.taskDialog = true;
    },
    // 修改团员/阶梯任务
    editMemberTask(row, $index) {
      this.memberCurrentIndex = $index;
      const copyRow = JSON.parse(JSON.stringify(row));
      this.isMemberTaskEdit = true;
      this.memberTaskForm = copyRow;
      this.memberTaskDialog = true;
    },
    // 上移
    upTask(arr, $index) {
      arr[$index] = arr.splice($index - 1, 1, arr[$index])[0];
    },
    // 下移
    downTask(arr, $index, stepIndex) {
      if (stepIndex >= 0) {
        arr[$index] = arr.splice($index + 1, 1, arr[$index])[0];
      } else {
        arr[$index] = arr.splice($index + 1, 1, arr[$index])[0];
      }
    },
    // 删除任务
    deleteTask($index, stepIndex) {
      if (stepIndex >= 0) {
        this.prizeSettingListStep[stepIndex].taskList.splice($index, 1);
      } else {
        this.taskDataList.splice($index, 1);
      }
    },
    deleMemberTask($index) {
      this.teamMemberTaskList.splice($index, 1);
    },
    getTaskDataList(selectList) {
      if (this.isStepTask) {
        this.prizeSettingListStep[this.selectedStep].taskList = selectList;
        this.taskDialog = false;
      } else {
        this.taskDataList = selectList;
        this.taskDialog = false;
      }
    },
    getMemberTaskDataList(selectList) {
      this.teamMemberTaskList = selectList;
      this.memberTaskDialog = false;
    },
    // 新增团长任务
    addTask(index) {
      if (index >= 0) {
        this.isStepTask = true;
        this.selectedStep = index; // 阶梯下标
      } else {
        this.isStepTask = false;
        this.selectedStep = null;
      }
      this.isTaskEdit = false;
      this.taskDialog = true;
    },
    // 新增团元任务
    addMemberTask() {
      this.isMemberTaskEdit = false;
      this.memberTaskDialog = true;
    },
    selectTemplate(index, id, item) {
      this.templateObj = item;
      this.templateId = id;
      this.templateJson.templateUItype = index;
      this.customerPaperwork.btnWordColor = item.rgb;
      this.currrentRgb = item.rgb;
    },
    onShopSetChange(value) {
      this.ruleDTO.goShopAppId = "";
      this.ruleDTO.goShopUrl = "";
    },

    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
    },
    // 京东计划数量计算
    prizeNum(row) {
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (row.totalAmount < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: "",
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList =
        data.records && data.records.length > 0
          ? data.records.map((item) => {
              return {
                ...item,
                days: item.activityStartTime
                  ? this.getDaysBetween(
                      item.activityStartTime,
                      item.activityEndTime
                    )
                  : "",
              };
            })
          : [];
      if (!this.templateId && this.giftList.length > 0) {
        this.templateId = this.giftList[0].id;
        this.templateJson.templateUItype = 0;
        this.customerPaperwork.btnWordColor = this.giftList[0].rgb;
        this.currrentRgb = this.giftList[0].rgb;
        this.templateObj = this.giftList[0];
      } else if (this.templateId) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.templateObj = arr[0];
        this.templateId = this.templateId;
        this.customerPaperwork.btnWordColor =
          this.customerPaperwork.btnWordColor;
        this.currrentRgb = this.templateObj.rgb;
      }
      this.pageData.total = data.total * 1;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    getConditionText(item) {
      let type_1 = ["商品", "指定商品", "非排除商品"];
      let str =
        item.taskType == 17
          ? `${item.orderStartTime}~${item.orderEndTime}期间下单付款${
              type_1[item.skuType]
            }${
              item.skuType == 2
                ? "的订单不计算入内,仅统计购买其他商品的商品件数及金额，"
                : ""
            }${
              item.itemStartCount
                ? "且商品件数：大于等于" + item.itemStartCount + "件"
                : ""
            }，${
              item.orderStartPayment
                ? "且订单金额：大于等于" + item.orderStartPayment + "元"
                : ""
            }，且订单状态为：${item.orderType == 1 ? "已完成" : "已付款"}`
          : this.getCondition(item);
      return str;
    },
    //生成规则
    generateRule() {
      let text1 = "参与方式：在活动有效期内，进入活动手动“开团”参与活动",
        text2 = "成团后团长需返回活动页领取奖品，成团不代表获得奖品，奖品以实际发放情况为主；",
        text3 = "如果是实物奖项，需填写收货地址后进行发货，活动结束后不允许填写地址，请在活动时间内填写地址，否则将视为放弃机会；",
        text10 = "",
        text11 = "",
        secondText = "\n二、【活动奖品】",
        thirdText = "\n三、【如何获奖】",
        fourthText = "\n四、【注意事项】",
        text12 = "";
        const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDTO,this.actMember)
      // 新增规则
      const sortArr = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
      const textArr = [
        "一",
        "二",
        "三",
        "四",
        "五",
        "六",
        "七",
        "八",
        "九",
        "十",
      ];
      text10 = `团长奖品：`;
      if (this.commanderForm.commanderPrizeType == 0) {
        text10 += "统一奖品\n";
        text10 += `（1）开团要求：${
          this.commanderForm.openTeamType == 0
            ? "符合参与对象可直接开团"
            : "符合参与对象，并且需要完成任务后方可开团"
        }`;
        if (this.commanderForm.openTeamType == 1) {
          this.taskDataList.forEach((item, index) => {
            text10 =
              text10 +
              "\n" +
              `      ` +
              sortArr[index] +
              this.getConditionText(item) +
              "；";
          });
        }
        text10 += `\n（2）成团人数：邀请${this.commanderForm.inviteTeamNum}人加入团队可得\n`;
        let prize = this.tableData[0];
        text10 += `（3）团长奖品：${prize.title}，共${
          prize.totalAmount
        }份${prize.prizeType==3 ? ('，单份奖品价值'+prize.price+'元') : ''}；`;
      } else {
        text10 += "阶梯奖品";
        this.prizeSettingListStep.forEach((item, index) => {
          text10 += `\n阶梯${textArr[index]}：`;
          text10 += `\n（1）开团要求：${
            item.openTeamType == 0
              ? "符合参与对象可直接开团"
              : "符合参与对象，并且需要完成任务后方可开团"
          }`;
          if (item.openTeamType == 1) {
            item.taskList.forEach((item, index) => {
              text10 =
                text10 +
                "\n" +
                `      ` +
                sortArr[index] +
                this.getConditionText(item) +
                "；";
            });
          }
          text10 += `\n（2）成团人数：邀请${item.inviteTeamNum}人加入团队可得`;
          let prize = item.table[0];
          text10 += `\n（3）团长奖品：${prize.title}，共${
            prize.totalAmount
          }份${prize.prizeType==3 ? ('，单份奖品价值'+prize.price+'元') : ''}；`;
        });
      }
      const memberPrize = this.teamMemberTable[0];
      if (memberPrize.title && memberPrize.prizeType) {
        text11 = `团员奖品：${memberPrize.title}，共${
          memberPrize.totalAmount
        }份${memberPrize.prizeType==3 ? ('，单份奖品价值'+memberPrize.price+'元') : ''}；先到先得，发完即止；`;
      } else {
        text11 = "";
      }

      text12 = "参团限制：即被邀请人需要符合以下条件；\n";
      let levelList = [];
      this.memberJoinSetting.allowLevel.forEach((item, index) => {
        let txt = "";
        if (item == "-1") {
          txt = "不限";
        } else if (item == "0") {
          txt = "非会员";
        } else {
          this.levelList.forEach((it, index) => {
            if (index + 1 == item) {
              txt = it;
            }
          });
        }
        levelList.push(txt);
      });
      text12 += "（1）团员身份要求：" + levelList.join(",") + "\n";
      text12 +=
        "（2）参团限制：" +
        (this.memberJoinSetting.filterInviteRuleType == 0
          ? "过滤同一活动中被邀请过的人\n"
          : "过滤所有活动中被邀请过的人\n");
      text12 += `（3）参团要求：${
        this.memberJoinSetting.openTeamType == 0
          ? "符合团员身份要求即可参团"
          : "符合团员身份要求，并且需要完成任务后方可参团"
      }`;
      if (this.memberJoinSetting.openTeamType == 1) {
        this.teamMemberTaskList.forEach((item, index) => {
          text12 =
            text12 +
            "\n" +
            `      ` +
            sortArr[index] +
            this.getConditionText(item) +
            "；";
        });
      }

      let Arr1 = [
        firstText,
        [secondText,text10,text11],
        [thirdText,text1,text12,text2,text3],
        [fourthText,precautions]
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText.trim();
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (
        this.actMember == 2 &&
        (!this.ruleForm.partner || this.ruleForm.partner.length == 0)
      ) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if (this.actMember == 3 && !this.peopleSelected.length) {
        this.$message.warning("请选择指定人群");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          !this.ruleForm.openCardBeforeDay
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleDTO.openCardStartTime || !this.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
      }
      // 奖品设置校验
      if (this.commanderForm.commanderPrizeType == 0) {
        if (
          this.commanderForm.openTeamType == 1 &&
          this.taskDataList.length == 0
        ) {
          return this.$message.warning("请添加开团任务");
        }
        if (!this.commanderForm.inviteTeamNum) {
          return this.$message.warning("请输入成团人数");
        }
        if (
          !this.tableData[0].prizeType ||
          !this.tableData[0].title ||
          !this.tableData[0].totalAmount
        ) {
          return this.$message.warning("请设置团长奖品");
        }
      } else if (this.commanderForm.commanderPrizeType == 1) {
        if (this.prizeSettingListStep.length <= 1) {
          return this.$message.warning("请至少设置两个阶梯");
        }
        let isNullText = null;
        this.prizeSettingListStep.forEach((item, index) => {
          if (
            item.openTeamType == 1 &&
            item.taskList.length == 0 &&
            !isNullText
          ) {
            isNullText = `请添加阶梯${index + 1}的开团任务`;
          }
          if (!item.inviteTeamNum && !isNullText) {
            isNullText = `请输入阶梯${index + 1}成团人数`;
          }
          // 邀请人数要递增
          if (
            index > 0 &&
            Number(item.inviteTeamNum) <=
              Number(this.prizeSettingListStep[index - 1].inviteTeamNum) &&
            !isNullText
          ) {
            isNullText = `阶梯${index + 1}成团人数需要大于上一个阶梯成团人数`;
          }
          item.table.forEach((list) => {
            if ((!list.totalAmount || !list.title) && !isNullText) {
              isNullText = `请输入阶梯${index + 1}奖品设置`;
            }
          });
        });
        if (isNullText) {
          return this.$message.warning(isNullText);
        }
      }
      if (this.teamMemberTable[0].prizeType) {
        if (
          !this.teamMemberTable[0].title ||
          !this.teamMemberTable[0].totalAmount
        ) {
          return this.$message.warning("请完善团员奖品设置");
        }
      }

      if (
        this.memberJoinSetting.openTeamType == 1 &&
        this.teamMemberTaskList.length == 0
      ) {
        return this.$message.warning("请添加参团要求任务");
      }

      //新增进店设置校验
      // if (this.ruleForm.goShopSetting == 1 && !this.ruleForm.goShopAppId) {
      //   this.$message.warning("请输入小程序appId");
      //   return;
      // }
      // if (this.ruleDTO.goShopSetting == 2) {
      //   if (!this.ruleDTO.goShopUrl) {
      //     this.$message.warning("请输入指定链接");
      //     return;
      //   } else if (
      //     !this.ruleDTO.goShopUrl.startsWith("https://") ||
      //     !this.ruleDTO.goShopUrl.includes("jd.com")
      //   ) {
      //     this.$message.warning(
      //       "输入的内容非链接或为接口无法支持的链接，请重新设置"
      //     );
      //     return;
      //   }
      // }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }
      // 小程序分享标题
      if (!this.ruleDTO.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleDTO.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if (this.ruleForm.isExposureItem&&this.itemListFor.length == 0) {
        this.$message.warning("请选择曝光商品");
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    // 统一处理任务数据
    handleTaskData(data, type, stepIndex = null) {
      const taskObj = {
        ...data,
        type,
        level: stepIndex + 1,
      };
      if ([3, 4, 12, 13].includes(data.taskType)) {
        taskObj.itemList = data.itemListForFilter;
        if (data.itemListForFilter && data.itemListForFilter.length) {
          taskObj.skuIds = data.itemListForFilter
            .map((item) => item.skuId)
            .join(",");
        }
        if ([3, 12, 13].includes(data.taskType)) {
          taskObj.viewCartLimit = data.taskCondition;
        } else {
          // 加购商品
          taskObj.addCartLimit = data.taskCondition;
        }
      }
      if (data.taskType == 17) {
        taskObj.itemList = data.selectGoodsFilterArr;
        if (data.selectGoodsFilterArr && data.selectGoodsFilterArr.length) {
          taskObj.skuIds = data.selectGoodsFilterArr
            .map((item) => item.skuId)
            .join(",");
        }
        taskObj.skuIds = []
        taskObj.venderIds = data.venderIds.join(",");
        taskObj.sellerSkuList = data.sellerSkuList.map((row)=>{
          return {
            skuIds: row.skuIds,
            venderId: row.venderId,
          }
        });
        taskObj.itemTotalLimit = data.itemStartCount;
        taskObj.amtLimit = data.orderStartPayment;
        // 指定商品规则提交，老数据无该字段时默认整单计算
        taskObj.statsSkuType = data.statsSkuType || 0;
      }
      return taskObj;
    },
    async handleDialogCloseAnoth() {
      // 任务列表处理
      let commonTaskList = [];
      if (
        this.commanderForm.commanderPrizeType == 0 &&
        this.commanderForm.openTeamType == 1
      ) {
        commonTaskList = this.taskDataList.map((item, index) => {
          return this.handleTaskData(item, 2);
        });
      } else if (this.commanderForm.commanderPrizeType == 1) {
        this.prizeSettingListStep.forEach((step, stepIndex) => {
          if (
            step.openTeamType == 1 &&
            step.taskList &&
            step.taskList.length > 0
          ) {
            // 遍历每个阶梯中的任务列表
            step.taskList.forEach((item, taskIndex) => {
              commonTaskList.push(this.handleTaskData(item, 2, stepIndex));
            });
          }
        });
      }
      if (this.memberJoinSetting.openTeamType == 1) {
        const arr = this.teamMemberTaskList.map((item, index) => {
          return this.handleTaskData(item, 3);
        });
        commonTaskList.push(...arr);
      }
      // 奖品处理
      let prizeList = [];
      let cumulativeTeamRules = []
      // 阶梯信息配置存储
      // let cumulativeTeamRules = [];
      // 统一奖品处理
      if (
        this.commanderForm.commanderPrizeType == 0 &&
        this.tableData.length > 0
      ) {
        prizeList = this.tableData.map((item) => {
          return {
            ...item,
            openTeamType: this.commanderForm.openTeamType,
            groupNums: this.commanderForm.inviteTeamNum,
            prizeObjectType: 0,
          };
        });
      } else if (
        this.commanderForm.commanderPrizeType == 1 &&
        this.prizeSettingListStep.length > 0
      ) {
        // 筛选阶梯奖品并添加指定字段
        this.prizeSettingListStep.forEach((step, index) => {
          if (step.table && step.table.length > 0) {
            step.table.forEach((prize) => {
              // 为每个奖品项添加所需字段
              const prizeWithFields = {
                ...prize,
                openTeamType: step.openTeamType || 0, // 开团类型，默认为0
                groupNums: step.inviteTeamNum || 0, // 成团人数，默认为0
                awardLevel: index + 1, // 奖励等级，从1开始
                taskIndex: index + 1,
                prizeObjectType: 0,
              };
              prizeList.push(prizeWithFields);
              cumulativeTeamRules.push({
                openTeamType: step.openTeamType || 0, // 开团类型，默认为0
                inviteTeamNum: step.inviteTeamNum||"", // 成团人数，默认为0
                awardLevel: index + 1, // 奖励等级，从1开始
              })
            });
          }
        });
      }
      if (
        this.teamMemberTable.length > 0 &&
        this.teamMemberTable[0].prizeType
      ) {
        let prizeArr = this.teamMemberTable.map((item) => {
          return { ...item, prizeObjectType: 1 };
        });
        prizeList.push(...prizeArr);
      }
      // 统一处理提交地址限制：数组转逗号分隔字符串
      prizeList = prizeList.map((item) => {
        if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
          item.commitAddressLimit = item.commitAddressLimit.join(',');
        }
        return item;
      });
      let ruleDTO = {
        ...this.ruleDTO,
        memberJoinSetting: {
          ...this.memberJoinSetting,
          allowLevel:
            this.memberJoinSetting.allowLevel &&
            this.memberJoinSetting.allowLevel.length
              ? this.memberJoinSetting.allowLevel.join(",")
              : "",
        },
        taskList: commonTaskList,
        openCardFollow: this.ruleForm.openCardFollow,
        firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
        openCardBeforeDay: this.ruleForm.openCardBeforeDay,
        ...this.commanderForm,
        isForceRemind: this.isForceRemind,
        cumulativeTeamRules: cumulativeTeamRules
      };
      let obj = {
        ...this.ruleForm,
        subType: 64,
        ruleDTO,
        pointActivityPrizeDTOList: [],
        taskList: commonTaskList,
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
      };
      obj.pointActivityPrizeDTOList = prizeList;

      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.ruleDTO.openCardStartTime =
        this.actMember == 2 ? this.ruleDTO.openCardStartTime : "";
      obj.ruleDTO.openCardEndTime =
        this.actMember == 2 ? this.ruleDTO.openCardEndTime : "";
      obj.ruleDTO.plusObject = this.ruleDTO.plusObject;
      // 其他活动页配置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork);

      //曝光商品集合设置
      obj.priceType = 0;
      obj.isExposureItem = this.ruleForm.isExposureItem ? 1 : 0;
      obj.itemList = this.itemListFor;

      // 模板
      obj.templateJson = this.templateJson;
      obj.templateId = this.templateId;

      // 活动对象处理
      // 参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      obj.allowLevel =
        this.ruleForm.partner && this.ruleForm.partner.length
          ? this.ruleForm.partner.join(",")
          : "";

      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel =
          this.ruleForm.partner && this.ruleForm.partner.length
            ? this.ruleForm.partner.join(",")
            : "";
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
      }
      delete obj.partner;
      delete obj.openCardFollow;
      delete obj.firstOpenCardTimeType;
      delete obj.openCardBeforeDay;
      if (this.checked == true || this.isDraft) {
        this.saveLoading = true;
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: prizeList.map((item) => {
              return {
                ...item,
                prizeId: item.id,
              };
            }),
            isExposureItem: this.ruleForm.isExposureItem ? 1 : 0, //曝光商品
            itemList: this.ruleForm.isExposureItem ? this.itemListFor : [],
            activityName: obj.activityName,
            condFollow: obj.condFollow ? 1 : 0,
            ruleDto: obj.ruleDTO,
            templateId: this.templateId,
            taskList: commonTaskList,
            endTime: this.ruleForm.endTime,
            isValidBlackList: this.ruleForm.isValidBlackList,
          };
          updateCommon(params)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success("修改成功");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
              this.saveLoading = false;
            });
        } else {
          if (this.isDraft) {
            obj.status = 5;
            delete obj.templateJson;
          } else {
            // 保存正式活动不需要status
            if (obj.status) delete obj.status;
            if (!this.activityData.isCopy) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.pointActivityId = this.valueRow.id;
                obj.id = this.valueRow.id;
              }
            } else {
              delete obj.templateJson;
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
            // 草稿箱不需要传 pointActivityId
            if (obj.pointActivityId) delete obj.pointActivityId;
          }
          saveActivityCommon(obj)
            .then((res) => {
              this.saveLoading = false;
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {
               this.saveLoading = false;
            });
        }
      } else {
        this.saveLoading = false;
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    // 任务回显统一回显
    getTaskData(taskList, type) {
      return taskList
        .filter((item) => item.type == type)
        .map((item) => {
          const obj = { ...item };
          const itemObj = this.taskTypeOptions.find(
            (list) => list.value == item.taskType
          );
          if (itemObj && itemObj.taskCondition) {
            obj.taskCondition = itemObj.taskCondition;
          }
          if ([3, 4, 12, 13].includes(item.taskType)) {
            obj.itemListForFilter = item.itemList ? item.itemList : [];
            if ([3, 12, 13].includes(item.taskType)) {
              obj.taskCondition = item.viewCartLimit;
            } else {
              // 加购商品
              obj.taskCondition = item.addCartLimit;
            }
          }
          if (item.taskType == 17) {
            obj.selectGoodsFilterArr = item.itemList ? item.itemList : [];
            obj.itemStartCount = item.itemTotalLimit;
            obj.orderStartPayment = item.amtLimit;
            obj.venderIds =
              item.venderIds
                ? item.venderIds.split(",").map((row) => +row)
                : [this.venderId];
            obj.sellerSkuList = item.sellerSkuList&&item.sellerSkuList.length?item.sellerSkuList:[{
                skuIds: item.skuIds ? item.skuIds.split(",") : [],
                venderId: this.venderId,
                itemList: [],
              }];
            if (this.activityData.isCopy||this.isDraftEdit) {
              // 跨店复制
              if(obj.venderIds.length>0) {
                let index = obj.venderIds.findIndex((item)=>{
                  return item == this.venderId
                })
                if(index==-1) {
                  obj.venderIds.unshift(Number(this.venderId))
                  obj.sellerSkuList.unshift({
                    venderId: Number(this.venderId),
                    skuIds: [],
                    itemList: [],
                  })
                }
              }
            }
            obj.orderPaymentType = item.orderPaymentType===null ? 1 : item.orderPaymentType;
            obj.mergeOrder = item.mergeOrder || false
          }
          return obj;
        });
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        this.loading = true;
        getActivityDetailCommon(this.valueRow.id)
          .then((res) => {
            const {
              activityName,
              startTime,
              endTime,
              ruleDto,
              isExposureItem,
              ruleDescription,
              allowLevel,
              crowdIds,
              condFollow,
              templateId,
              pointActivityPrizeDTOList,
              isKeyActivity,
              placementPosition,
              studentSatus,
            } = res.data;
            const {
              commanderPrizeType,
              openTeamType,
              inviteTeamNum,
              taskList,
              openCardFollow,
              cumulativeTeamRules,
              firstOpenCardTimeType,
              openCardBeforeDay,
              isForceRemind,
            } = ruleDto;
            this.ruleForm.activityName =
              activityName + (this.activityData.isCopy ? "复制" : "");

            this.ruleForm.condFollow = condFollow ? true : false;
            this.ruleForm.isValidBlackList = res.data.isValidBlackList;
            // 活动对象配置
            if (allowLevel == "99") {
              this.peopleSelected = crowdIds.split(",");
              this.actMember = "3";
            } else if (allowLevel == "-1") {
              this.actMember = "1";
              this.ruleForm.partner = ["-1"];
            } else {
              this.actMember = "2";
              if (allowLevel.indexOf("-1") != -1) {
                this.ruleForm.partner = ["-1"];
              } else {
                this.ruleForm.partner = allowLevel.split(",");
              }
            }
            this.ruleForm.openCardFollow = openCardFollow;
            this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;
            this.ruleForm.openCardBeforeDay = openCardBeforeDay;
            this.ruleDTO = ruleDto;
            this.commanderForm.commanderPrizeType = commanderPrizeType;
            this.commanderForm.openTeamType = openTeamType;
            this.commanderForm.inviteTeamNum = inviteTeamNum;
            this.memberJoinSetting = ruleDto.memberJoinSetting;
            this.memberJoinSetting.allowLevel =
              ruleDto.memberJoinSetting.allowLevel.split(",");
            delete this.ruleDTO.memberJoinSetting;
            this.isForceRemind = isForceRemind;
            this.isKeyActivity = isKeyActivity||0;
            this.placementPosition = placementPosition ? placementPosition.split(",") : ["SHOP"];
            // 学生身份
            this.ruleForm.studentSatus = studentSatus || "";
            // 统一处理奖品地址限制回显：逗号分隔字符串转数字数组
             pointActivityPrizeDTOList.forEach((item) => {
              if (item.prizeType == 3) {
                if (item.commitAddressLimit) {
                  item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                    ? item.commitAddressLimit.split(',').map(Number)
                    : item.commitAddressLimit;
                } else {
                  item.commitAddressLimit = [0];
                }
              }
              // return item;
            });
            // 奖品回显
            // 团长奖品
            if (commanderPrizeType == 0) {
              // 统一奖品
              this.tableData = pointActivityPrizeDTOList.filter(
                (item) => item.prizeObjectType == 0
              );
            } else {
              // 阶梯奖品
              if(cumulativeTeamRules&&cumulativeTeamRules.length>0){
                this.prizeSettingListStep = cumulativeTeamRules.map((item) => {
                  let obj = {
                    ...item,
                    table: [],
                    taskList: [],
                  };
                  obj.table = pointActivityPrizeDTOList.filter(
                    (row) =>
                      row.prizeObjectType == 0 &&
                      row.awardLevel == item.awardLevel
                  );
                  return obj;
                });
              }
            }
            // 团员奖品
            const teamPrizes = pointActivityPrizeDTOList.filter(
              (item) => item.prizeObjectType == 1
            );
            if (teamPrizes && teamPrizes.length > 0) {
              this.teamMemberTable = teamPrizes;
            }
            if (
              this.commanderForm.commanderPrizeType == 0 &&
              this.commanderForm.openTeamType == 1
            ) {
              // 统一奖品任务
              this.taskDataList = this.getTaskData(taskList, 2);
            }
            // 团员任务
            if (this.memberJoinSetting.openTeamType == 1) {
              this.teamMemberTaskList = this.getTaskData(taskList, 3);
            }
            // 阶梯任务
            const stepList = this.getTaskData(taskList, 2);
            stepList.forEach((item) => {
              this.prizeSettingListStep.forEach((step) => {
                if (item.level == step.awardLevel) {
                  step.taskList.push(item);
                }
              });
            });

            if (ruleDto.customerPaperwork) {
              this.customerPaperwork = JSON.parse(ruleDto.customerPaperwork);
            }
            this.templateId = templateId;
            this.getPolite();
            this.loading = false;

            // v2.5 => 复制不需要回显奖品和规则
            if (!this.activityData.isCopy) {
              this.ruleForm.startTime = startTime;
              this.ruleForm.endTime = endTime;
              this.activityStartTime = startTime;
              this.activityEndTime = endTime;

              this.ruleForm.isExposureItem = isExposureItem ? true : false;
              this.itemListFor = res.data.itemList;
              this.ruleForm.ruleDescription = ruleDescription;
            }
            this.templateJson = JSON.parse(res.data.templateJson);
            if (this.activityData.isCopy) {
              // 是否为统一奖品
              if (this.commanderForm.commanderPrizeType == 0) {
                this.tableData = [
                  {
                    assetsId: null, // 资产项id(计划id优惠卷id商品id)
                    prizeType: 0,
                    price: null,
                    logo: null,
                    title: "",
                    totalAmount: null,
                  },
                ];
              } else if (this.commanderForm.commanderPrizeType == 1) {
                this.prizeSettingListStep.forEach((item, index) => {
                  item.table = [
                    {
                      assetsId: null, // 资产项id(计划id优惠卷id商品id)
                      prizeType: 0,
                      price: null,
                      logo: null,
                      title: "",
                      totalAmount: null,
                    },
                  ];
                });
              }
              this.teamMemberTable = [
                {
                  assetsId: null, // 资产项id(计划id优惠卷id商品id)
                  prizeType: 0,
                  price: null,
                  logo: null,
                  title: "",
                  totalAmount: null,
                },
              ];
              this.ruleForm.ruleDescription = "";
            }
          })
          .catch((res) => {});
      } else {
        this.activityStartTime = this.$getDate(30)[0];
        this.activityEndTime = this.$getDate(30)[1];
        this.hdTaskTemplateGroup();
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
  }
  .ml8 {
    margin-left: 8px;
  }
  .mt12 {
    margin-top: 12px;
  }
  .tips_red {
    color: #ff4d4f;
  }
  .buttonGroup {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #666;
  }
  .prize_box {
    background: #fafafa;
    padding: 10px;
    border-radius: 4px;
    &_middle {
      padding-top: 10px;
    }
    &_step {
      margin-top: 16px;
      &_top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 4px 10px;
        background-color: #f0f2f7;
        &__delete {
          cursor: pointer;
        }
      }
      &_center {
        background-color: #fff;
        padding: 10px 0px;
      }
    }
  }
  .btn-bg {
    margin-top: 5px;
    width: 80px;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
